// --------------------------------------------------------------------------
// togglePopup.js
// --------------------------------------------------------------------------

RN.togglePopup = function() {

    'use strict';
    var $body = document.querySelector('body')
    var scrollPosition = window.pageYOffset;

    function init() {
    byBehaviour('toggle-popup').on('click', togglePopup);
        if (!getWithExpiry(btoa(window.location.href) + '-popupDismissed')) {
            if ($('[data-element="popup"]').length > 0) {
                $('[data-element="popup"]').removeClass('u-hidden')
                $body.style.overflow = 'hidden';
                $body.style.position = 'fixed';
                $body.style.top = '-' + scrollPosition + 'px';
                $body.style.width = '100%';
            }
        }
    }

    function togglePopup() {
        $(this).parents('[data-element="popup"]').addClass('u-hidden')
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);
        var milliseconds = 86400000 // = day
        setWithExpiry(btoa(window.location.href) + '-popupDismissed', true, milliseconds)
    }

    function setWithExpiry(key, value, ttl) {
        var now = new Date()
        var item = {
            value: value,
            expiry: now.getTime() + ttl
        }
        localStorage.setItem(key, JSON.stringify(item))
    }

    function getWithExpiry(key) {
        var itemStr = localStorage.getItem(key)
        if (!itemStr) {
            return null
        }
        var item = JSON.parse(itemStr)
        var now = new Date()
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key)
            init()
            return null
        }
        return item.value
    }

  return {
    init: init
  };

}();
